import { DataTimeSeries } from '@trace/types';
import mean from 'lodash.mean';

export interface LatestValueAndChange {
  change: number | null;
  value: number | null;
}

export interface ComparisonValues {
  allVersionsLatest: LatestValueAndChange;
  allVersionsAverage: LatestValueAndChange;
}

const getNonNullValues = (dataSeries: DataTimeSeries = []): number[] =>
  dataSeries.filter((valueOrNull) => valueOrNull !== null) as number[];

/**
 *
 * @param a The value to be comparing
 * @param b The value to be compared against
 *
 * @returns  A percentage value between 0 - 100
 */
export const getChange = (a?: null | number, b?: null | number): null | number => {
  const change = (a || 0) / (b || 0) - 1;

  if (Number.isNaN(a) || Number.isNaN(b) || !Number.isFinite(change)) {
    return null;
  }

  return change * 100;
};

export const getComparisonValues = (data: DataTimeSeries = []): ComparisonValues => {
  const aggregatedValues = getNonNullValues(data);

  const aggregatedLatestValue = aggregatedValues[aggregatedValues.length - 1];
  const aggregatedLatestSecondValue = aggregatedValues[aggregatedValues.length - 2];

  const aggregatedAverage = mean(aggregatedValues);

  return {
    allVersionsLatest: {
      change: getChange(aggregatedLatestValue, aggregatedLatestSecondValue),
      value: aggregatedLatestValue || null,
    },
    allVersionsAverage: {
      change: getChange(aggregatedLatestValue, aggregatedAverage),
      value: aggregatedAverage || null,
    },
  };
};
